import { Promise } from 'rsvp';
import Service, { inject as service } from '@ember/service';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

/**
 * Service for sh-payment-line-item related API calls
 */
export default Service.extend({
  api: service(),
  store: service(),
  shData: service(),

  /**
   * Add a payment line item
   *
   * @param {ShPayment} shPayment
   * @param {String} type     of type ShBillableLineItem.TYPES.*
   * @param {Number} amount
   * @param {String} description
   * @return {Ember.RSVP.Promise}
   */
  addPaymentLineItem(shPayment, type, amount, description) {
    let options = {
      jsonData: {
        'type' : type,
        'amount' : amount,
        'description': description
      }
    };

    this.shData.addIncludesToOptions(options, []);

    return new Promise((resolve, reject) => {
      this.get('api').post(`sh-payments/${shPayment.get('id')}/sh-payment-line-items/`, options).then(response => {
        this.shData.pushResponseToStore(response);
        let shPaymentLineItem = this.get('store').peekRecord('shPaymentLineItem', response.data.id);
        resolve(shPaymentLineItem);
      }).catch(e => {
        handleErrorResponseWithModal(
          this,
          e,
          'There was an error creating the line item. Please refresh and try again.',
          'addPaymentLineItem -- error creating payment line item for app id : ' + application.get('id'),
        );
        reject(e);
      });
    });
  },
});
